import * as React from 'react';
export const chatSvg = React.forwardRef(function chatSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.409 2.26C3.859 1.157 5.83.5 7.985.5c2.156 0 4.136.667 5.592 1.777C15.034 3.387 16 4.974 16 6.782c0 1.8-.958 3.38-2.408 4.484s-3.422 1.765-5.577 1.765a9.8 9.8 0 0 1-1.387-.083L2.746 15.35a.712.712 0 0 1-.039.022c-.788.426-1.821-.283-1.51-1.255l.971-3.064C.847 9.953 0 8.462 0 6.749 0 4.943.957 3.364 2.409 2.26Zm.908 1.194C2.154 4.338 1.5 5.51 1.5 6.75c0 1.302.705 2.51 1.978 3.42a.75.75 0 0 1 .278.837l-.77 2.431 3.093-1.913a.75.75 0 0 1 .54-.098c.418.083.89.105 1.396.105 1.858 0 3.503-.571 4.668-1.458C13.847 9.187 14.5 8.016 14.5 6.78c0-1.238-.66-2.417-1.832-3.311C11.495 2.576 9.842 2 7.985 2c-1.859 0-3.504.569-4.668 1.454Z',
    }),
  );
});
chatSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chat = {
  category: 'icon',
  colorable: true,
  name: 'chat',
  svg: chatSvg,
};
